<template>
  <label
    ref="$input"
    class="bear-select"
    spellcheck="false"
    autocapitalize="false"
    autocomplete="off"
    :class="{ 'bear-select-disabled': disabled }"
    :style="style">
    <el-select :disabled="disabled" :multiple="options.Multiple" class="hidden-select" v-model="value" @change="handleChange">
      <el-option v-for="(obj, i) in selectOptions" :key="i"
        v-show="!obj.Hidden"
        :label="obj.Name"
        :value="obj.Value"
        :disabled="obj.Disabled"
      ></el-option>
    </el-select>
    <template v-if="multiple">
      <template v-for="(v, i) in value" :key="i">
        {{ v }}<el-icon class="icon-date-close" style="margin: 0 10px 0 5px" @click="spliceValue(i)"><circle-close /></el-icon>
      </template>
    </template>
    <template v-else>
      {{ text }}
      <el-icon v-if="value && value.length && !disabled" class="icon-date-close" @click="clearValue"><circle-close /></el-icon>
    </template>
  </label>
</template>
<script>
import { mapState } from "vuex";
import { CircleClose } from "@element-plus/icons-vue";
import utils from "../../common/js/utils";
export default {
  name: "BearSelect",
  components: {
    CircleClose,
  },
  props: {
    modelValue: {
      type: [String, Number, Array],
      default: "",
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["selections"]),
    multiple() {
      return this.options.Multiple;
    },
    style() {
      let { minWidth } = this.attrs;
      // if(this.multiple) {
      //   return {
      //     display: 'inline-block',
      //     minWidth: minWidth || '100px'
      //   }
      // }
      let len = this.textLength;
      let x = 10;
      if (minWidth) {
        x = Math.ceil(minWidth.replace(/\D/g, "") / 16);
      }
      if (len > x) {
        return {
          minWidth: minWidth || "100px",
        };
      } else {
        return {
          display: "inline-block",
          minWidth: minWidth || "100px",
        };
      }
    },
    textLength() {
      return utils.getTextLength(this.text);
    },
    text() {
      if (this.value instanceof Array) {
        return this.value.join();
      } else if (/showName/.test(this.options.Type)) {
        return this.selectOptions[this.value] ? this.selectOptions[this.value].Name : "";
      } else if (/showByValue/.test(this.options.Type)) {
        const matchedOption = this.selectOptions.find((obj) => obj.Value === this.value);

        return matchedOption ? matchedOption.Name : "";
      }
      return this.value;
    },
    selectOptions() {
      let { Options, OptionsFromStore } = this.options;
      if (OptionsFromStore) {
        return this.selections[OptionsFromStore] || [];
      } else {
        return Options;
      }
    },
  },
  data() {
    return {
      value: this.initValue(),
    };
  },
  created() {
    if (this.modelValue) {
      this.value = this.modelValue;
    }
  },
  methods: {
    handleChange() {
      this.$emit("update:modelValue", this.value);
      this.emitChange();
    },
    clearValue() {
      this.value = this.initValue();
      this.$emit("update:modelValue", this.value);
      this.emitChange();
    },
    spliceValue(index) {
      this.value.splice(index, 1);
      this.$emit("update:modelValue", this.value);
      this.emitChange();
    },
    emitChange() {
      this.$emit("change", this.value);
    },
    initValue() {
      if (this.multiple) {
        return [];
      } else {
        return "";
      }
    },
  },
  watch: {
    modelValue(value) {
      this.value = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.bear-select {
  position: relative;
  z-index: 1;
  text-indent: 0;
  word-break: break-all;
  line-height: 1;
  padding: 5px 5px;
  width: auto;
  min-width: 100px;
  cursor: pointer;
  text-align: left;
  outline: none;
  color: #2393e4;
  border-bottom: 1px solid black;
}
.bear-select-disabled {
  background: #eee;
  cursor: not-allowed;
}
.icon-date-close {
  color: #a8abb2;
  vertical-align: text-bottom;
  cursor: pointer;
  &:hover {
    color: #2393e4;
  }
}
</style>
<style lang="scss">
.tender-form-item {
  .hidden-select {
    width: 0px !important;
    height: 16px;
    overflow: hidden;
    vertical-align: text-bottom;
  }
  .is-error {
    .bear-select {
      border-bottom: 1px solid red;
      & + .el-form-item__error {
        position: relative;
        display: inline;
        padding: 5px 5px;
        background: #efdede;
        border-bottom: 1px solid red;
        border-radius: 0 3px 0 0;
      }
    }
  }
}
</style>